import { render, staticRenderFns } from "./ProviderForm.vue?vue&type=template&id=607a9bc4&"
import script from "./ProviderForm.vue?vue&type=script&lang=js&"
export * from "./ProviderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('607a9bc4')) {
      api.createRecord('607a9bc4', component.options)
    } else {
      api.reload('607a9bc4', component.options)
    }
    module.hot.accept("./ProviderForm.vue?vue&type=template&id=607a9bc4&", function () {
      api.rerender('607a9bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/global/ProviderForm.vue"
export default component.exports